var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center w-100"},[_c('font-awesome-icon',{staticClass:"cursor-pointer text-warning",staticStyle:{"cursor":"pointer","font-size":"1.2rem"},attrs:{"icon":_vm.isFavorite ? ['fas', 'star'] : ['far', 'star']},on:{"click":_vm.onToggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }